var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"device-status-control"},[_c('el-tooltip',{attrs:{"content":_vm.getStatusTooltip(),"placement":"top","open-delay":500}},[_c('el-tag',{attrs:{"type":_vm.statusInfo.type,"size":"medium"}},[_vm._v(" "+_vm._s(_vm.statusInfo.label)+" ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }